import { render, staticRenderFns } from "./UploadPhotos.vue?vue&type=template&id=3b537946"
import script from "./UploadPhotos.vue?vue&type=script&lang=js"
export * from "./UploadPhotos.vue?vue&type=script&lang=js"
import style0 from "./UploadPhotos.vue?vue&type=style&index=0&id=3b537946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports